import PageLoader from './PageLoader'
export default PageLoader
export { PageLoader }
